export class AttendanceSystem {
  constructor() {
    this.attendanceRecords = new Map();
    this.currentDate = new Date().toISOString().split('T')[0];
    this.employees = []; // To be populated with employer employees
  }

  initializeEmployees(employeeList) {
    this.employees = employeeList;
    this.employees?.forEach(emp => {
      if (!this.attendanceRecords.has(emp.id)) {
        this.attendanceRecords.set(emp.id, new Map());
      }
    });
  }

  recordAttendance(employeeId) {
    const today = new Date().toISOString().split('T')[0];
    const employeeRecord = this.attendanceRecords.get(employeeId);

    if (employeeRecord.has(today)) {
      return { success: false, message: "Attendance already recorded for today." };
    }

    employeeRecord.set(today, { status: 'present', timestamp: new Date() });
    return { success: true, message: "Attendance recorded successfully." };
  }

  checkAttendance(employeeId) {
    const today = new Date().toISOString().split('T')[0];
    const employeeRecord = this.attendanceRecords.get(employeeId);
    return employeeRecord?.get(today)?.status || 'absent';
  }

  markAbsentAtEndOfDay() {
    const today = new Date().toISOString().split('T')[0];
    const endOfDay = new Date(today);
    endOfDay.setHours(23, 59, 59, 999);
    
    // This method should be called at the end of the day (e.g., via a scheduled task)
    if (new Date() >= endOfDay) {
      this.employees.forEach(emp => {
        const record = this.attendanceRecords.get(emp.id);
        if (!record.has(today)) {
          record.set(today, { status: 'absent', timestamp: endOfDay });
        }
      });
      this.currentDate = new Date().toISOString().split('T')[0]; // Update to next day
    }
  }

  getAttendanceStats(employeeId, period) {
    const now = new Date();
    const stats = { present: 0, absent: 0 };
    const records = this.attendanceRecords.get(employeeId);

    records?.forEach((record, date) => {
      const recordDate = new Date(date);
      let isWithinPeriod = false;

      if (period === 'week') {
        isWithinPeriod = now.toLocaleDateString() === recordDate.toLocaleDateString() ||
                         now.getDate() - recordDate.getDate() <= 7;
      } else if (period === 'month') {
        isWithinPeriod = now.getMonth() === recordDate.getMonth() &&
                         now.getFullYear() === recordDate.getFullYear();
      } else if (period === 'year') {
        isWithinPeriod = now.getFullYear() === recordDate.getFullYear();
      }

      if (isWithinPeriod) {
        if (record.status === 'present') stats.present++;
        else if (record.status === 'absent') stats.absent++;
      }
    });

    return stats;
  }
}